import {useEffect, useState} from "react";

export default function useResponsive() {
  const [isMobileLike, setIsMobileLike] = useState(false);
  const [observerSupported, setObserverSupported] = useState(true);

  useEffect(() => {
    setObserverSupported(typeof window !== "undefined" && "IntersectionObserver" in window);
    const mq = window.matchMedia("(max-width: 768px)");
    const onMQ = (e) => setIsMobileLike(e.matches);
    setIsMobileLike(mq.matches);
    mq.addEventListener ? mq.addEventListener("change", onMQ) : mq.addListener(onMQ);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", onMQ) : mq.removeListener(onMQ);
    };
  }, []);

  return { isMobileLike, observerSupported };
}